import { Component, OnInit } from '@angular/core';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { UsuarioRolService } from '../../containers/bandeja-principal/administrador/configuracion/usuario-rol/usuario-rol.service';

@Component({
	selector: 'app-modal-seleccion-usuario',
	templateUrl: './modal-seleccion-usuario.component.html',
	styleUrls: ['./modal-seleccion-usuario.component.scss']
})

export class ModalSeleccionUsuarioComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerUsuarios: Array<string>;
	usuarioSeleccionado: any;
	filtro: FormGroup;
	modalGenerico: ModalGenericoModel;
	paginaActual: number;
	public isCollapsed = true;
	tipoUsuario: Array<any> = [];

	constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder, private usuarioRolService: UsuarioRolService,
		private usuarioService: UsuarioRolService) {

		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;

		this.formulario();
		this.usuarioSeleccionado = null;
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.modalGenerico = {
			titulo: 'Seleccionar Usuario'
		};
		this.headerUsuarios = ['', 'Número identificación', 'Tipo de usuario', 'Usuario', 'Correo electrónico',
			'Fecha de creación', 'Estado'];
		this.onConsultarUsuario(1);
		this.usuarioService.getTipoUsuario().subscribe(resultado => {
			if (resultado.data) {
				this.tipoUsuario = resultado.data;
			}
		});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarUsuario(value);
	}

	onConsultarUsuario(page: number) {
		this.usuarioRolService.getUsuario({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	formulario() {
		this.filtro = this.formBuilder.group({
			numero_identificacion: [null],
			tipo_usuario_id: [null],
			usuario: [null],
			correo_electronico: [null],
			activo: [null],
		});
	}

	selection(value) {
		this.usuarioSeleccionado = value;
	}

	confirm(): void {
		if (this.activeModal && this.usuarioSeleccionado) {
			this.activeModal.close(this.usuarioSeleccionado);
		}
	}

	dismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarUsuario(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}

}
